import React from 'react'
import styled from 'styled-components'
import { mobileWidthMax } from '@edulastic/colors'

const QuestionFieldset = styled.fieldset`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: ${({ showQuestionNumber }) =>
    showQuestionNumber ? 'calc(100% - 51px)' : '100%'};
  margin-left: auto;
  border: none;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  @media (max-width: ${mobileWidthMax}) {
    flex-wrap: wrap;
  }
`

const QuestionContentWrapper = ({ children, showQuestionNumber }) => (
  <QuestionFieldset
    showQuestionNumber={showQuestionNumber}
    className="question-content-wrapper __print_question-content-wrapper"
  >
    {children}
  </QuestionFieldset>
)

export default QuestionContentWrapper
